<template>
    <SettingsPage title="Dashboard Settings">
        <template #settingsForms>
            <!-- Platform User (basic, premium, plus) Dashboard -->
            <SettingsForm
                :settingsLoading="settingsLoading"
                form="userDashboardSettings"
            >
                <template #title>
                    User Dashboard
                </template>
                <template #form>
                    <form
                        action=""
                        method="POST"
                        id="userDashboardSettings"
                        @submit.prevent="saveUserDashboard"
                        v-if="!settingsLoading && settings"
                    >
                        <v-text-field
                            label="Dashboard Title"
                            name="userDashboardTitle"
                            v-model="settings.userDashboardTitle"
                            outlined
                        />
                        <v-text-field
                            label="Dashboard Subtitle"
                            name="userDashboardSubtitle"
                            v-model="settings.userDashboardSubtitle"
                            outlined
                        />
                        <v-text-field
                            label="Notification"
                            name="userDashboardNotification"
                            v-model="settings.userDashboardNotification"
                            outlined
                        />
                        <v-text-field
                            label="Welcome Video Embed ID"
                            name="userDashboardWelcomeVideoEmbed"
                            v-model="settings.userDashboardWelcomeVideoEmbed"
                            outlined
                        />
                        <label for="userDashboardWelcomeText">Welcome Text</label>
                        <quill-editor
                            label="Welcome Text"
                            id="userDashboardWelcomeText"
                            name="userDashboardWelcomeText"
                            v-model="settings.userDashboardWelcomeText"
                            outlined
                        />
                    </form>
                </template>
            </SettingsForm>
        </template>
    </SettingsPage>
</template>

<script>
import settingsMixin from '@/views/Admin/Config/Settings/Common/settingsMixin';
import SettingsForm from '@/views/Admin/Config/Settings/Common/SettingsForm';
import SettingsPage from '@/views/Admin/Config/Settings/Common/SettingsPage';

export default {
    components: { SettingsPage, SettingsForm },
    mixins: [ settingsMixin ],
    props: [],

    data() {
        return {
            settingPage: 'dashboard',
            settingName: 'settingDashboard',
            postData: {},
        };
    },

    methods: {
        saveUserDashboard() {
            const settings = {
                userDashboardNotification: this.settings.userDashboardNotification,
                userDashboardWelcomeVideoEmbed: this.settings.userDashboardWelcomeVideoEmbed,
                userDashboardWelcomeText: this.settings.userDashboardWelcomeText,
                userDashboardSubtitle: this.settings.userDashboardSubtitle,
                userDashboardTitle: this.settings.userDashboardTitle,
                userDashboardNotificationButtonUrl: this.settings.userDashboardNotificationButtonUrl,
            };

            this.saveSettings(this.settingPage, this.setPostData(`${this.settingName}User`, settings));
        },
    }
};
</script>
